import { ResourceService } from 'src/app/global/services/resource.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { WEB_API } from 'src/app/global/services/web-api';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ReturnAPI, Page } from '../domain/return-api.model';
import { Observable } from 'rxjs';
import { Produto } from '../domain/produto.model';
import { CarteiraCliente } from '../domain/carteira-cliente.model';
import { CarteiraClienteSerializer } from '../serializables/carteira-cliente.serializer';

@Injectable()
export class CarteiraClienteService extends ResourceService<CarteiraCliente> {
  static RESOURCE = 'carteira-cliente';
  produto: Produto;
  produtoId: string;

  constructor(private http: HttpClient) {
    super(http, `${WEB_API}`, CarteiraClienteService.RESOURCE, new CarteiraClienteSerializer(CarteiraCliente));
  }

  findAll(queryOption: QueryOptions): Observable<ReturnAPI<Page<CarteiraCliente>>> {
    this.getProduto();
    return this.httpClient.get<ReturnAPI<Page<CarteiraCliente>>>(
      `${WEB_API}/${CarteiraClienteService.RESOURCE}?${queryOption.toQueryString()}&${this.produtoId}`,
    );
  }

  save(carteiraCliente: CarteiraCliente): Observable<ReturnAPI<CarteiraCliente>> {
    this.getProduto();
    return this.httpClient.post<ReturnAPI<CarteiraCliente>>(
      `${WEB_API}/${CarteiraClienteService.RESOURCE}/save?${this.produtoId}`,
      carteiraCliente,
    );
  }

  getProduto(): void {
    if (sessionStorage.getItem('produto')) {
      this.produto = JSON.parse(sessionStorage.getItem('produto'));
      this.produtoId = Number.isInteger(this.produto.id) ? 'produtoId=' + this.produto.id : '';
    }
  }
}
